import Cookies from 'js-cookie';
import imSdk from '@laigu/im-sdk';

export const initIm = () => {
  if (!window.im) {
    const entId = Cookies.get('_enterprise_id');
    const agentId = Cookies.get('_agent_id');
    const token = Cookies.get('_authenticated');
    window.im = imSdk({ entId, agentId, token });
  }
};

export const getIm = () => {
  return window.im || { on: () => {}, off: () => {}, promiseEmit: () => {}, promiseOn: () => {} };
};
